import React from 'react';
import Svg from "../Svg";

const TrackTypeLightIcon = props => (
   <Svg width="30px" height="30px" viewBox="30 30">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
         <g transform="translate(-25.000000, -637.000000)">
            <g transform="translate(24.000000, 453.000000)">
               <g transform="translate(1.000000, 184.000000)">
                  <circle
                     stroke="#AFE6FF" strokeWidth="3" fill="#2FBEFF" cx="15" cy="15"
                     r="13.5"/>
                  <path
                     d="M11.1890909,10.12 L9.88727273,8.81090909 L8.86181818,9.83636364 L10.1709091,11.1381818 L11.1890909,10.12 Z M7,15.7272727 L9.18181818,15.7272727 L9.18181818,14.2727273 L7,14.2727273 L7,15.7272727 Z M12.8181818,22.2363636 L17.1818182,22.2363636 L17.1818182,18.7381818 C18.4836364,17.9818182 19.3636364,16.5781818 19.3636364,14.9636364 C19.3636364,12.5563636 17.4072727,10.6 15,10.6 C12.5927273,10.6 10.6363636,12.5563636 10.6363636,14.9636364 C10.6363636,16.5781818 11.5163636,17.9818182 12.8181818,18.7381818 L12.8181818,22.2363636 Z M14.2727273,17.9018182 L13.5454545,17.48 C12.6436364,16.9563636 12.0909091,15.9963636 12.0909091,14.9636364 C12.0909091,13.3563636 13.3927273,12.0545455 15,12.0545455 C16.6072727,12.0545455 17.9090909,13.3563636 17.9090909,14.9636364 C17.9090909,15.9963636 17.3498182,16.9563636 16.4545455,17.48 L15.7272727,17.9018182 L15.7272727,20.7818182 L14.2727273,20.7818182 L14.2727273,17.9018182 Z M20.8181818,15.7272727 L23,15.7272727 L23,14.2727273 L20.8181818,14.2727273 L20.8181818,15.7272727 Z M14.2727273,9.18181818 L15.7272727,9.18181818 L15.7272727,7 L14.2727273,7 L14.2727273,9.18181818 Z M21.1454545,9.84363636 L20.12,8.81818182 L18.8181818,10.1272727 L19.8436364,11.1527273 L21.1454545,9.84363636 Z"
                     fill="#FFFFFF"/>
               </g>
            </g>
         </g>
      </g>
   </Svg>
);

export default TrackTypeLightIcon;
